export default __webpack_public_path__ + "images/720d49ae57d83594fc8e999e01c12618-hightech.webp";